module.exports = __webpack_public_path__ + "media/ets/7-4548cd7f.png";